import React, { useEffect } from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  HStack,
  ModalFooter,
  Box,
  DrawerFooter,
} from "@chakra-ui/react";
import { track, EVENTS } from "../../../../utils/analytics";

import InsightsManagerHeader from "./InsightsManagerHeader";
import InsightsManagerContent from "./InsightsManagerContent";

interface InsightsManagerDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  isUserAdmin: boolean;
  controller: any;
}

const InsightsManagerDrawer: React.FC<InsightsManagerDrawerProps> = ({
  isOpen,
  onClose,
  isUserAdmin,
  controller,
}) => {
  // Add tracking when drawer is opened
  useEffect(() => {
    if (isOpen) {
      track(EVENTS.TOOLBAR.INSIGHT_BUTTON_CLICKED, {
        action: "opened",
      });
    }
  }, [isOpen]);

  return (
    <Drawer
      onClose={() => {
        // Track when drawer is closed
        track(EVENTS.TOOLBAR.INSIGHT_BUTTON_CLICKED, {
          action: "closed",
        });
        onClose();
      }}
      size="100%"
      isOpen={isOpen}
    >
      <DrawerOverlay />
      <DrawerContent bg="var(--bg)">
        <DrawerCloseButton />
        <HStack pr="12px">
          <InsightsManagerHeader
            isUserAdmin={isUserAdmin}
            controller={controller}
          />
        </HStack>
        <DrawerBody p="0" pb="100px">
          <InsightsManagerContent controller={controller} onClose={onClose} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default InsightsManagerDrawer;
